<template>
  <div>
    <!-- <el-input
      type="text"
      @click.native="addCLassForStu"
      v-model="this.teacherName"
      placeholder="请选择老师"
      :disabled="doWhat == 'view'"
    ></el-input> -->

    <!-- <span :disabled="doWhat == 'view'">{{ teacherName }}</span> -->
    <el-button
      size="mini"
      type="primary"
      @click="addCLassForStu"
      color="#C5C5C5"
      v-if="doWhat !== 'view'"
      >请选择</el-button
    >
    <!-- <Icon
      type="ios-add-circle-outline"
      size="30"
      @click="addCLassForStu"
      color="#C5C5C5"
      v-if="doWhat !== 'view'"
      style="border:1px solid red"
    /> -->
    <ul v-if="teacherName.length">
      <li v-for="(item, index) in teacherName" :key="index">
        <span>{{ item.name }}</span>
        <span>
          <Icon
            type="ios-close"
            size="22"
            color="#C5C5C5"
            v-if="doWhat != 'view'"
            icon="close"
            @click="delData(index)"
          />
        </span>
      </li>
    </ul>

    <Modal v-model="modalShow" width="760" footer-hide>
      <p slot="header" style="text-align: center; font-size: 15px">
        <Icon type="ios-information-circle"></Icon>
        <span>
          <slot></slot>
        </span>
      </p>

      <queryTeacherBar @deputyResult="queryHandle" />
      <div>
        <el-table
          ref="multipleTable"
          :data="queryData"
          stripe
          border
          :row-key="getRowKey"
          tooltip-effect="dark"
          class="cus-table elTable"
          style="width: 100%"
          :reserve-selection="true"
          highlight-current-row
          @select="handleSelect"
        >
          <el-table-column type="selection" reserve-selection width="55">
          </el-table-column>
          <el-table-column prop="id" label="老师ID" align="center" width="90">
            <template slot-scope="scope">
              <a href="javascript:;" style="color: #1d90e6">{{
                scope.row.id
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="老师"
            align="center"
            min-width="120"
          >
            <template slot-scope="scope">
              <a href="javascript:;" style="color: #1d90e6">{{
                scope.row.name
              }}</a>
            </template>
          </el-table-column>
          <el-table-column
            prop="phone"
            label="联系方式"
            align="center"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="office"
            label="职务"
            align="center"
            min-width="100"
          ></el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="queryParams.page"
            :page-sizes="[20, 50, 100]"
            :page-size="queryParams.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </div>
      <Divider />
      <el-button type="primary" @click="modalConfirm" style="margin-left: 266px"
        >确定</el-button
      >
      <el-button type="primary" @click="modalCancel">取消</el-button>
    </Modal>
  </div>
</template>

<script>
import { ApiMessage } from "@/utils/util";
import queryTeacherBar from "./queryTeacherBar";
export default {
  name: "deputyTeacher",
  components: { queryTeacherBar },
  data() {
    return {
      modalShow: false,
      pageTotal: 0,
      queryData: [],
      queryParams: {
        page: 1,
        pageSize: 20,
      },
      loading: true,
      queryTerms: null,
      tempRadio: "",
      name: "",
      phone: "",
      office: "",
      id: "",
      multipleSelection: [],
      teacherName: [],
      doWhat: "",
    };
  },
  props: {
    oldClass: {
      type: Number,
      default: null,
    },
    btnDisable: {
      type: Boolean,
      default: false,
    },
    btnSize: {
      type: String,
      default: "mini",
    },
    len: {
      type: Number,
      default: 1,
    },
    mainTeacherName: {
      type: [String, Array],
      default: "",
    },
  },
  created() {
    // debugger;
    if (this.$route.query.do != undefined) {
      this.doWhat = this.$route.query.do;
    }
    // console.log(this.multipleSelection, "mutio");
  },
  watch: {
    mainTeacherName: {
      handler: function (va) {
        // debugger
        if (va) {
          //  debugger
          if (Array.isArray(va)) {
            // debugger
            // debugger
            var arr = [];
            // this.queryData.length && this.queryData.forEach(item => {
            //   va.forEach(cu => {
            //     debugger
            //     if (item.id === cu.id || cu.teacherId) {
            //        arr.push(item)
            //     }
            //   })
            // })
            // console.log(arr, 'arr')
            this.teacherName = va;
            this.multipleSelection = [...this.teacherName];

            return;
          }
          this.teacherName = va;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  updated() {
    this.$nextTick(() => {
      // debugger
      // debugger
      // this.$refs.multipleTable.clearSelection();
      // if (this.$refs.multipleTable) console.log("执行几次");
      if (this.teacherName && this.teacherName.length) {
        console.log(this.multipleSelection, "sssssssssss");
        this.multipleSelection.forEach((row) => {
          // debugger;
          this.queryData.forEach((item) => {
            if (item.id === row.id) {
              console.log("执行了几次");
              this.$refs.multipleTable.toggleRowSelection(item, true);
            }
          });
        });
      }
    });
  },
  methods: {
    delData(index) {
      this.teacherName.splice(index, 1);
      this.multipleSelection.splice(index, 1);
      this.$emit(
        "deputyResult",
        this.teacherName.map((item) => item && item.id && item.id.toString())
      );
    },
    getRowKey(row) {
      return row.id;
    },
    addCLassForStu() {
      //   這裏
      if (this.doWhat != "view") {
        if (this.len > 0) {
          this.modalShow = true;
          this.queryParams.page = 1;
          this.fetchClassList("ref");
        } else {
          alert("请先选择学生");
          return;
        }
      }
    },
    fetchClassList(type) {
      this.loading = true;
      let params = {
        appId: this.$API.APPID,
      };
      if (this.queryTerms != null) {
        if (this.queryTerms.name != "") {
          params.name = this.queryTerms.name;
        }
        if (this.queryTerms.office != "") {
          params.office = this.queryTerms.office;
        }
      }

      params.pageSize = this.queryParams.pageSize;
      params.page = this.queryParams.page;
      this.eduAxiosPostRequest("/edu/eduAdmin/teacher/list", params).then(
        (res) => {
          if (res != null) {
            // debugger
            let m = JSON.parse(res);
            this.queryData = m.list;
            this.pageTotal = m.pager.total;

            this.$nextTick(() => {
              // debugger
              this.$refs.multipleTable.clearSelection();
              // if (this.$refs.multipleTable) console.log("执行几次");
              if (this.teacherName && this.teacherName.length) {
                console.log(this.multipleSelection, "sssssssssss");
                this.multipleSelection.forEach((row) => {
                  // debugger;
                  this.queryData.forEach((item) => {
                    if (item.id === row.id) {
                      console.log("执行了几次");
                      this.$refs.multipleTable.toggleRowSelection(item, true);
                    }
                  });
                });
              }
            });
          }
          this.loading = false;
        }
      );
    },
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.fetchClassList();
    },
    handleCurrentChange(val) {
      this.queryParams.page = val;
      this.fetchClassList();
    },
    modalConfirm() {
      this.teacherName = [...this.multipleSelection];
      console.log(this.teacherName, "sdasd");
      // debugger
      this.$emit(
        "deputyResult",
        this.multipleSelection.map(
          (item) => item && item.id && item.id.toString()
        )
      );
      this.modalShow = false;
    },
    modalCancel() {
      this.modalShow = false;
    },
    fun1(data) {
      let hash = {};
      const data2 = data.reduce((preVal, curVal) => {
        hash[curVal.id] ? "" : (hash[curVal.id] = true && preVal.push(curVal));
        return preVal;
      }, []);
      return data2;
    },
    fun(arr) {
      let newArr = [...arr];
      let indexArr = [];
      arr.forEach((s, i) => {
        let count = 0;
        newArr.forEach((m, j) => {
          if (arr[i].id == newArr[j].id) {
            //当属性值都相同时，打印索引位置
            count++;
          }
        });
        // console.log("索引:",i,"相同次数:",count)
        if (count > 1) {
          //内层循环结束，当count>1,说明此索引为对象是重复的
          indexArr.push(i);
        }
      });
      // console.log(indexArr) //相同对象索引数组
      let flag = -1;
      for (var i = 0; i < indexArr.length; i++) {
        //删除一次，索引位
        flag++;
        if (flag == 0) {
          newArr.splice(indexArr[i], 1);
        } else {
          newArr.splice(indexArr[i] - flag, 1); // 每次删除，需要删除的索引位就要减去1
        }
      }
      return newArr;
    },
    queryHandle(param) {
      //点击搜索
      // console.log(param);
      this.queryParams.page= 1
      this.queryTerms = param;
      this.fetchClassList();
    },
    handleSelect(val, row) {
      var mapId = this.multipleSelection.map((item) => item.id);

      if (!mapId.includes(row.id)) {
        // 回显数据里没有本条，把这条加进来(选中)
        this.multipleSelection.push(row);
      } else {
        // 回显数据里有本条，把这条删除(取消选中)
        this.multipleSelection.forEach((item, index) => {
          if (item.id === row.id) {
            this.multipleSelection.splice(index, 1);
          }
        });
      }
      // console.log(this.multipleSelection, "mution");
    },

    eduAxiosPostRequest(address, params) {
      return new Promise((resolve, reject) => {
        this.$axios
          .post(address, params)
          .then((response) => {
            // console.log(response);
            if (response.data.rc == "0") {
              resolve(JSON.stringify(response.data.data));
            } else {
              alert(response.data.rc + ". " + response.data.err);
              reject(null);
            }
          })
          .catch((error) => {
            ApiMessage(this, error.toString(), "error");
            reject(null);
          });
      });
    },
  },
};
</script>

<style lang="less" scoped>
ul {
  li {
    padding: 0 6px;
    border: 1px solid #e8eaec;
    border-radius: 3px;
    background: #f7f7f7;
    font-size: 12px;
    line-height: 20px;
    margin: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// deputyTeacher.vue?668c14a4